import Supabase from "@/utils/Supabase"
import FontAwesome from "@/utils/FontAwesome"
export default  app => {

    app.provide('Supabase', Supabase)


    FontAwesome(app)

}